import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=5cf51037&scoped=true"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=5cf51037&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf51037",
  null
  
)

export default component.exports